import { useState, useEffect } from 'react';
import logoAnimated from '../images/logo_animated.gif';
import './IntroSplashScreen.css';

const IntroSplashScreen = ({ onComplete }) => {
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fading out after 2.8 seconds so full GIF animation completes
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, 2800);

    // Completely unmount splash overlay after 3.3 seconds
    const removeTimer = setTimeout(() => {
      setVisible(false);
      if (onComplete) onComplete();
    }, 3300);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, [onComplete]);

  if (!visible) return null;

  return (
    <div className={`intro-splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        <div className="splash-logo-wrapper">
          <img src={logoAnimated} alt="NexaAI Studio Loading" className="splash-gif-logo" />
        </div>
        <div className="splash-brand-text">
          <span className="splash-main">Nexa<span className="orange">AI</span></span>
          <span className="splash-sub">STUDIO</span>
        </div>
        <div className="splash-loader-bar">
          <div className="splash-loader-fill"></div>
        </div>
      </div>
    </div>
  );
};

export default IntroSplashScreen;
